/*= ====== Include All App Css and Js Files =======*/
// Uer For Quill Editor
import 'react-quill/dist/quill.snow.css';
// Use For Switch
import 'react-toggle-switch/dist/css/switch.min.css';
// Use for weather icons
import 'weather-icons/css/weather-icons.min.css';
// Use Themify Icon
import 'Assets/themify-icons/themify-icons.css';
// Use For Full Calender
import 'react-big-calendar/lib/css/react-big-calendar.css';
// notifications
import 'react-notifications/lib/notifications.css';
// tour
import 'react-joyride/lib/react-joyride-compiled.css';
// calendar
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
// editor
// import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
// Algolia css
import 'instantsearch.css/themes/algolia.css';
// Credit Card
import 'react-credit-cards/src/styles.scss';
// Custom Style File
import 'Assets/scss/_style.scss';
